var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activateSpinner
        ? _c("spinner")
        : _c("div", [
            _vm.formType !== "edit"
              ? _c("div", [
                  _c(
                    "div",
                    [
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.security.pem"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "d-flex form-group" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      "input-value":
                                        _vm.currentKeystore[0].name,
                                      isMandatory: "",
                                      inputLabel: _vm.$t(
                                        "common.security.name"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.name"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mx-auto mb-4" }),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.security.certificat"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex align-items-center form-group",
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group mb-5",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue: _vm.getDate(
                                        _vm.currentKeystore[0].startDate
                                      ),
                                      inputLabel: _vm.$t(
                                        "common.security.startDate"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.startDate"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group mb-5",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue: _vm.getDate(
                                        _vm.currentKeystore[0].endDate
                                      ),
                                      inputLabel: _vm.$t(
                                        "common.security.endDate"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.endDate"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue:
                                        _vm.currentKeystore[0].deliveredBy,
                                      inputLabel: _vm.$t(
                                        "common.security.deliveredBy"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.deliveredBy"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      inputValue:
                                        _vm.currentKeystore[0].deliveredTo,
                                      inputLabel: _vm.$t(
                                        "common.security.deliveredTo"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.deliveredTo"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mx-auto mb-4" }),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("common.security.private_key"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center form-group",
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group mb-5",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-read-group-label-input", {
                                    attrs: {
                                      "input-value":
                                        _vm.currentKeystore[0].password,
                                      inputLabel: _vm.$t(
                                        "common.security.password"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "common.security.password"
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-col", {
                                staticClass: "form-group mb-5",
                                attrs: { sm: "6" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _c(
                  "div",
                  [
                    _c("keystore-form-pem", {
                      ref: "keystoreFormPem",
                      attrs: { store: 1, keystore: _vm.currentKeystore[0] },
                    }),
                  ],
                  1
                ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }